export enum FeatureToggle {
  marketingToolingEnabled = 'rt_rfm_v2_enabled',
  marketingToolingRetailerEnabled = 'rt_rfm_v2_retailer_enabled',
  segmentLibraryEnabled = 'rt_segment_library_v2_enabled',
  targetingApiSegmentToolingEnabled = 'rt_targeting_api_segment_tooling_enabled',
}
